/* eslint-disable import/prefer-default-export */
import client from 'core/axios';
import RequestMethod from 'core/axios/RequestMethod';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';

export const getStudentAssessments = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `/${version}/assessments/student-assessments/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Get the SEL Average Scores
 *
 *
 * @param {Object} params
 * @param {Number} params.student - student id
 */
export const getSelAverageScores = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `/${version}/assessments/sel-average-scores/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSelQuestions = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `/${version}/assessments/sel/questions/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSelAnswerCounts = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `/${version}/assessments/sel/answer-counts/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSelLatestAnswerStudents = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `/${version}/assessments/sel/latest-answer-students/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSelStats = ({ params = {}, version = 'v1' }) =>
  client
    .request({
      url: `/${version}/assessments/sel/stats/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
